import { getCurrencySymbolFromCurrencyCode } from '@shared/utils/currency/utils';
import type { CurrencyCodeType } from '@shared/utils/currency/currency.types';

export type FormattedCurrency = Readonly<{
  name: string;
  code: CurrencyCodeType;
  symbol: string;
  flag: string;
  inputDisplay: string;
  shortDisplay: string;
  popoverDisplayLine1: string;
  popoverDisplayLine2: string;
}>;

type FormatCurrencyOptions = Readonly<{
  hideFlag?: boolean;
}>;

/**
 * Format currency data for display in the selector
 * @param code - Currency code (e.g., 'USD')
 * @param name - Translated currency name (e.g., "United States Dollar")
 * @param flag - Flag emoji (e.g., "🇺🇸")
 * @param options - Display options (e.g., hideFlag)
 * @returns Formatted currency object with display strings
 */
export function formatCurrency(code: CurrencyCodeType, name: string, flag: string, options?: FormatCurrencyOptions): FormattedCurrency {
  const symbol = getCurrencySymbolFromCurrencyCode(code);
  const showFlag = !options?.hideFlag;
  const flagPrefix = showFlag ? `${flag} ` : '';

  return {
    name,
    code,
    symbol,
    flag,
    // Input display: "🇺🇸 United States Dollar (USD $)" or "United States Dollar (USD $)"
    inputDisplay: `${flagPrefix}${name} (${code} ${symbol})`,
    // Short input display: "USD - $"
    shortDisplay: `${code} - ${symbol}`,
    // First line in menu: "🇺🇸 United States Dollar" or "United States Dollar"
    popoverDisplayLine1: `${flagPrefix}${name}`,
    // Second line in menu: "USD - $"
    popoverDisplayLine2: `${code} - ${symbol}`,
  };
}
